<template>
  <div>
    <basic-container>
      <div>
        <el-form
          ref="form"
          :model="serviceItemForm"
        >
          <el-form-item label="服务类目名称">
            <div style="display: flex;width:300px;">
              <el-select
                v-model="serviceItemForm.superiorId"
                placeholder="请选择服务类目名称"
                width="300"
                @change="selectSuperiorId"
              >
                <el-option
                  v-for="item in superiorIds"
                  :key="item.id"
                  :label="item.name"
                  :value='item.id'
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="服务项目名称">
            <div style="display: flex;width:300px;">
              <el-select
                v-model="serviceItemForm.serviceCategoryName"
                placeholder="请选择服务类目名称"
                width="300"
                @change="selectCategory"
                value-key="id"
              >
                <el-option
                  v-for="item in categoryTypes"
                  :key="item.id"
                  :label="item.name"
                  :value='item'
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="服务质保配置">
            <div
              v-for="(item,index) in tableData1"
              :key="index"
            >
              <el-table
                :data="item"
                :span-method="objectSpanMethod"
                border
                style="width: 100%; margin-top: 20px"
              >
                <el-table-column
                  prop="yyqd"
                  label="预约渠道"
                  min-width="120"
                >
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.clientType"
                      disabled
                      width="300"
                    >
                      <el-option
                        v-for="item in clientTypes"
                        :key="item.value"
                        :label="item.label"
                        :value='item.value'
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="area"
                  min-width="250"
                  label="服务区域"
                >
                  <template slot-scope="scope">
                    <div>
                      <el-input
                        v-model='scope.row.area'
                        disabled
                      >
                      </el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="type"
                  label="质保时间类型"
                  min-width="100"
                >
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.type"
                      placeholder="请选择质保时间类型"
                      width="300"
                    >
                      <el-option
                        v-for="item in types"
                        :key="item.value"
                        :label="item.label"
                        :value='item.value'
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="time"
                  label="质保时间"
                  min-width="100"
                >
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.time"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="fileList"
                  label="电子质保卡"
                  min-width="100"
                >
                  <template slot-scope="scope">
                    <el-upload
                      class="upload-demo"
                      action="#"
                      ref="upload"
                      list-type="picture"
                      :on-remove="handleRemove"
                      :multiple="true"
                      :http-request="fnUploadDescribeImgs"
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="scope.row.fileList"
                    >
                      <el-button
                        size="small"
                        type="primary"
                        @click="isIndex(index)"
                      >点击上传</el-button>
                      <div
                        slot="tip"
                        class="el-upload__tip"
                      >只能上传jpg/png文件，且不超过500kb</div>
                    </el-upload>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </el-form>
        <div style='width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:20px'>
          <el-button
            type="primary"
            size="big"
            @click="submit"
          >确定新增</el-button>
        </div>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { DIC } from "@/const/dic";
import { resolveUrlPath, setUrlPath } from "@/util/util";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";
import { findProject, addGuarantee } from "@/api/work/serviceWarranty";

export default {
  data() {
    return {
      fileList: [],
      tableData1: {},
      clientTypes: DIC.SERVICEITEM_TYPE,
      superiorIds: [],
      categoryTypes: [],
      currIndex: "",
      serviceItemForm: {},
      isTop: "YES",
      yyTypes: DIC.SERVICEITEM_YYTYPE,
      types: DIC.SERVICE_WARRANTY_DATE_TYPE,
      tableData: []
    };
  },
  created() {
    findProject().then(res => {
      let data = JSON.parse(res.data);
      this.superiorIds = data;
    });
  },
  methods: {
    selectSuperiorId(e) {
      console.log(e);
      let params = {};
      params.superiorId = e;
      findProject(params).then(res => {
        console.log(res);
        let data = JSON.parse(res.data);
        this.categoryTypes = data;
        this.serviceItemForm.serviceCategoryName = {};
        this.tableData1 = [];
      });
    },
    selectCategory(e) {
      console.log(e);
      if (e.channel == null) {
        this.$message({
          showClose: true,
          message: e,
          type: "error"
        });
        return;
      }
      let list = e.channel.split(",");
      let obj = {};
      for (let i in list) {
        console.log(e.configs[i]);
        let dtobj = {};
        dtobj.clientType = e.configs[i].clientType;
        dtobj.agentId = e.configs[i].agentId;
        dtobj.configId = e.configs[i].id;
        dtobj.area =
          (e.configs[i].provinceName == null ? "" : e.configs[i].provinceName) +
          (e.configs[i].cityName == null ? "" : e.configs[i].cityName) +
          (e.configs[i].areaName == null ? "" : e.configs[i].areaName);
        list[i] = [];
        list[i].push(dtobj);
        obj[i] = list[i];
      }
      console.log(list);
      console.log(obj);
      this.tableData1 = obj;
      this.$nextTick(() => {
        for (let j in list) {
          if (this.$refs.upload[j]) {
            this.$refs.upload[j].clearFiles();
          }
        }
      });
    },
    isIndex(e) {
      console.log(e);
      console.log(this);
      this.currIndex = e;
    },
    handleRemove(file, fileList) {
      console.log(this);
      console.log(file, fileList);
      this.fileList = fileList;
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    submit() {
      console.log(this);
      let item = {
        close: true,
        label: "新增服务质保",
        value: "/work/serviceWarranty/add"
      };
      let list = [];
      for (let item in this.tableData1) {
        console.log(this.tableData1[item]);
        list.push(this.tableData1[item][0]);
      }
      console.log(list);
      let params = list;
      addGuarantee(params).then(res => {
        console.log(res);
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success"
          });
          if (!this.isPas) {
            this.$store.commit("DEL_TAG", item);
            let obj = {
              value: "/work/serviceWarranty",
              label: "服务质保管理"
            };
            this.$router.push({
              path: resolveUrlPath(obj.value, obj.label),
              query: obj.query
            });
            this.isPas = true;
          }
        } else {
          if (!this.isPas) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
            this.isPas = true;
            setTimeout(() => {
              this.isPas = false;
            }, 1000);
          }
        }
      });
    },
    handleSteppingDelete(index, row) {
      //   this.propertiesList.splice(index, 1);

      this.tableData.splice(index, 1);
    },
    handleAddRows(index, row) {
      let list = {
        yyType: "",
        id: "",
        name: "",
        amount1: "",
        amount2: "",
        amount3: ""
      };
      this.tableData.push(list);
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 8) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    async fnUploadDescribeImgs(option) {
      this.tableLoading = true;
      console.log(option);
      var obj = {};
      obj.name = option.file.name;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            console.log(results);
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            // this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            obj.url = array[0];
            console.log(obj);
            //上传多张图片
            // if (this.tableData1[this.currIndex][0].image == undefined) {
            //   this.tableData1[this.currIndex][0].image = array[0];
            // } else {
            //   let aa = "";
            //   this.tableData1[this.currIndex][0].image = aa.concat(
            //     this.tableData1[this.currIndex][0].image,
            //     ",",
            //     array[0]
            //   );
            //   console.log(this.tableData1[this.currIndex][0].image);
            // }
            // 上传单张图片
            this.tableData1[this.currIndex][0].image = array[0];
            // this.fileList.push(obj);
            this.describeImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch(err => {});
      });
    }
  }
};
</script>

<style>
</style>